import React from 'react';
import type { IconProps } from './types';

// Glifo de relleno, a juego con AppleIcon.
const AndroidIcon: React.FC<IconProps> = ({ size = 14, color = 'currentColor', ...props }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color} {...props}>
    <path d="M16.32 8.24l1.4-2.42a.29.29 0 00-.11-.4.29.29 0 00-.4.11l-1.42 2.45a8.78 8.78 0 00-7.58 0L6.79 5.53a.29.29 0 00-.4-.11.29.29 0 00-.11.4l1.4 2.42C5.24 9.54 3.71 11.95 3.5 14.8h17c-.21-2.85-1.74-5.26-4.18-6.56zM8.06 12.2a.73.73 0 110-1.46.73.73 0 010 1.46zm7.88 0a.73.73 0 110-1.46.73.73 0 010 1.46z" />
    <path d="M3.5 15.86v2.6c0 .58.47 1.05 1.05 1.05h.86v2.05a1.2 1.2 0 102.4 0v-2.05h8.38v2.05a1.2 1.2 0 102.4 0v-2.05h.86c.58 0 1.05-.47 1.05-1.05v-2.6z" />
  </svg>
);

export default AndroidIcon;
